<div class="container-fluid ps-0 pe-0">
  <div class="row d-flex align-items-center">
    <div class="col-12">
      <strong>Select the files you would like to annotate</strong>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <mat-form-field>
        <mat-select placeholder="Document category" (selectionChange)="changeDocumentCategory($event.value)">
          <mat-option *ngFor="let document of documentCategories" [value]="document">
            {{ document.name || document.text }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="datatable-accordion mat-elevation-z2">
        <div class="table-responsive">
          <table class="table table-striped table-fixed table-hover table-sm mb-0">
            <thead class="table-header">
            <tr>
              <th></th>
              <th>Filename</th>
              <th>Type</th>
            </tr>
            </thead>
            <tbody>
              <tr *ngFor="let file of files; let i = index;">
                <td style="width: 10%;"><mat-checkbox (click)="selectFile(file)" [(ngModel)]="file.checked"></mat-checkbox></td>
                <td>{{file.name}}</td>
                <td>{{file.typeCode}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
